// Polyfills
import 'regenerator-runtime/runtime';
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import analytics, {initialAnalytics} from '../lib/analytics';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

initialAnalytics();
// Register "base" page view
analytics.send({hitType: 'pageview', page: '/community/web'});

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    try {
        require('./render-gui.jsx').default(appTarget);
    } catch (err) {
        if (typeof console !== 'undefined' && console.error) {
            console.error('[Labcode] Erro ao carregar o editor:', err);
        }
        const splash = document.getElementById('pre-loading');
        if (splash && splash.parentNode) {
            splash.parentNode.removeChild(splash);
        }
        appTarget.textContent = '';
        const p = document.createElement('p');
        p.style.cssText = 'padding:1.5rem;font-family:sans-serif;';
        p.textContent =
            'Erro ao carregar o Labcode. Veja a consola (F12). Se acabou de guardar ficheiros, aguarde o webpack ' +
            'terminar (“Compiled successfully”) e recarregue.';
        appTarget.appendChild(p);
    }

} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
    const splash = document.getElementById('pre-loading');
    if (splash && splash.parentNode) {
        splash.parentNode.removeChild(splash);
    }
}
